import { constants } from '@/services/constants.service'
export default {
  computed: {
    isBlockedStatus () {
      return Object.values(constants.exam_blocked_status).includes(this.exam.status)
    }
  },
  methods: {
    getIsBlockedStatus (status) {
      return Object.values(constants.exam_blocked_status).includes(status)
    }
  }
}
